import comp from "./SelectedCollaboratorsList";
export default comp;
